import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HdmuiNavigationService } from '@heidelberg/hdmui-angular';
import { BreadcrumbsService } from '@data-terminal/utils/breadcrumbs';
import { isSecondLevel, NavigationService } from '@data-terminal/data-access/navigation/navigation.service';

export function provideNavigationService(): HdmuiNavigationService {
    const breadcrumbsService = inject(BreadcrumbsService);
    const navigationService = inject(NavigationService);

    return {
        breadcrumbs: toSignal(breadcrumbsService.breadcrumbs$, { initialValue: [] }),
        isSecondLevel: toSignal(navigationService.navData$.pipe(isSecondLevel), { initialValue: false }),
    };
}
